import md5 from 'js-md5';

//组合参数并排序 格式化参数
export function formatParams(params = {}) {
  return Reflect.ownKeys(params).sort().reduce((Accumulator, Current) => ({ ...Accumulator, [Current]: params[Current] }), {});
}

//格式化为url参数 json拼接url
export function queryString(params = {}) {
  // return Reflect.ownKeys(params).map(key => params[key] && `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).filter(item => item).join('&');
  return Reflect.ownKeys(params).filter(item => params[item] !== undefined && params[item] !== '').map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).join('&');
}

// 通过md5签名加密
export function md5sign(params, method = 'GET') {
  const formatData = formatParams({
    ...params,
    appid: 'cpcook_025f5f2d91',
    key: '9437e5e9487f523fa16d1d01bcde9631',
    timestamp: (new Date()).valueOf()
  });
  const queryStringJson = queryString(formatData);
  return method.toUpperCase() === 'GET' ? formatParams({ ...formatData, sign: md5(queryStringJson).toUpperCase() }) : formatData;
}